import axios from "../initializers/axios"

import {
  CommentsApi,
  Configuration,
  CurrentMemberApi,
  DigestApi,
  EventsApi,
  GroupApi,
  GroupMemberApi,
  MembersApi,
  PostsApi,
  TagsApi,
  TopicsApi,
  FoldersApi,
  DriveFilesApi,
  RsvpsApi,
  DriveApi,
  PushDeviceApi,
  EventMediaApi,
  HighlightsApi,
  CustomAttributeDefinitionsApi,
  ClientApi,
  LevelApi,
  ForumItemsApi,
  AddressesApi,
} from "suus-api"

const configuration = new Configuration({ basePath: axios.defaults.baseURL })
export const commentsApi = new CommentsApi(configuration, undefined, axios)
export const currentMemberApi = new CurrentMemberApi(
  configuration,
  undefined,
  axios
)
export const digestApi = new DigestApi(configuration, undefined, axios)
export const eventsApi = new EventsApi(configuration, undefined, axios)
export const groupApi = new GroupApi(configuration, undefined, axios)
export const groupMemberApi = new GroupMemberApi(
  configuration,
  undefined,
  axios
)
export const membersApi = new MembersApi(configuration, undefined, axios)
export const postsApi = new PostsApi(configuration, undefined, axios)
export const tagsApi = new TagsApi(configuration, undefined, axios)
export const topicsApi = new TopicsApi(configuration, undefined, axios)
export const foldersApi = new FoldersApi(configuration, undefined, axios)

export const driveApi = new DriveApi(configuration, undefined, axios)
export const driveFilesApi = new DriveFilesApi(configuration, undefined, axios)

export const rsvpApi = new RsvpsApi(configuration, undefined, axios)
export const pushDeviceApi = new PushDeviceApi(configuration, undefined, axios)
export const eventMediaApi = new EventMediaApi(configuration, undefined, axios)
export const highlightsApi = new HighlightsApi(configuration, undefined, axios)
export const clientApi = new ClientApi(configuration, undefined, axios)
export const forumItemsApi = new ForumItemsApi(configuration, undefined, axios)
export const levelApi = new LevelApi(configuration, undefined, axios)
export const customAttributeDefinitionsApi = new CustomAttributeDefinitionsApi(
  configuration,
  undefined,
  axios
)
export const addressesApi = new AddressesApi(configuration, undefined, axios)
